import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="w-full bg-ink-raised" data-id="element-59" data-mp="1he2xdzcpzofn">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-60" data-mp="1cf9mmeotibj6">
        <div className="grid gap-6 lg:grid-cols-[0.7fr_1fr] lg:gap-16" data-id="element-61" data-mp="2a1ys4yiqb69s">
          <h2 id="faq" className="font-display text-3xl text-cream sm:text-4xl" data-id="element-62" data-mp="2a05ug8q3fwdx">
            Preguntas frecuentes
          </h2>

          <ul className="divide-y divide-line border-y border-line" data-id="element-63" data-mp="203swgynimwdd">
            {faqs.map((faq, index) => {
            const isOpen = open === index;
            return <li key={faq.question} data-id="element-64" data-mp="1v72e24o8noos" data-mpi={index}>
                  <h3 data-id="element-65" data-mp="opf9rx4i0myx">
                    <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-66" data-mp="opypd76oez9s">
                      <span className={`font-sans text-[16px] font-medium leading-snug transition-colors duration-150 ease-out ${isOpen ? 'text-gold' : 'text-cream'}`} data-id="element-67" data-mp="1kngspufxbawq">
                        {faq.question}
                      </span>
                      <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-amethyst transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-68" data-mp="1apar7dy146se" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-69" data-mp="16nyxaw84gzee">
                    {isOpen ? <motion.div key="content" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-70" data-mp="16picsklyf6f4">
                        <p className="pb-6 pr-10 text-[15px] leading-relaxed text-muted" data-id="element-71" data-mp="2pn58he9kfci3">
                          {faq.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}